<template>
  <div class="sendLink">
    <div class="content content-border">
      <h2>Send Payment Link</h2>
      <v-button
        @click="onSendSignature(1)"
      >Using SMS</v-button>
      <v-button
        @click="onSendSignature(2)"
      >Email</v-button>
    </div>
    <div  class="content">
      <h2>Save Quote</h2>
      <v-button
        @click="onAddTicket">Save Quote to Customer Account</v-button>
    </div>
  </div>
</template>

<script>
import {
  paymentLinkSend
} from '@api/quote'

export default {
  name: 'sendLink',
  props:{
    orderId: {
      type: [String, Number],
      default: ''
    },
    customerId: {
      type: [String, Number],
      default: ''
    },
    quote_no: {
      type: [String, Number],
      default: ''
    },
    isReferralRequest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onAddTicket() {
      if(this.isReferralRequest) {
        this.$emit('saveQuote', {
          order_id: this.orderId,
          customer_id:this.customerId,
          quote_no:this.quote_no
        })
        return
      }
      this.$router.push({
        path: '/quoting/save/quote',
        query: {
          order_id: this.orderId,
          customer_id:this.customerId,
          quote_no:this.quote_no
        }
      })
    },
    //發送類型（1：SMS，2：Email）
    onSendSignature(type) {
      this.checking = true
      setTimeout(() => {
        this.checkedVerify = true
      }, 1000)
      this.network().paymentLinkSend(type)
    },

    network() {
      return {
        paymentLinkSend: async (type) => {
          let { data } = await paymentLinkSend({
            order_id: this.orderId,
            send_type:type
          })
          this.$message({
            type: 'success',
            message: data.message
          })
          if(this.isReferralRequest) {
            this.$emit('send', {
              order_id: this.orderId,
              customer_id:this.customerId,
              quote_no:this.quote_no
            })
            return
          }
          this.$router.push({
            path: '/quoting/send/link',
            query: {
              order_id: this.orderId,
              customer_id:this.customerId,
              quote_no:this.quote_no
            }
          })
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sendLink{
  margin-top: 30px;
  .content{
    padding: 31px 0;
  }
  .content-border{
    border-bottom: 1px solid #E1E4E8;
    border-top: 1px solid #E1E4E8;
  }
}

</style>